import { defineComponent as _defineComponent } from 'vue';
import { computed } from "vue";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faChevronUp, faChevronDown } from "@fortawesome/free-solid-svg-icons";
export default /*#__PURE__*/ _defineComponent({
    __name: 'TextSummary',
    props: {
        description: {
            type: String,
            required: true,
        },
        showDetails: {
            type: Boolean,
            default: false,
        },
        maxLength: {
            type: Number,
            default: 150,
        },
    },
    emits: ["update:show-details"],
    setup(__props, { emit }) {
        const props = __props;
        const propShowDetails = computed({
            get: () => {
                return props.showDetails;
            },
            set: (val) => {
                emit("update:show-details", val);
            },
        });
        library.add(faChevronUp, faChevronDown);
        const collapsedEnableIcon = "fas fa-chevron-down";
        const collapsedDisableIcon = "fas fa-chevron-up";
        // summarized length
        const x = Math.round(props.maxLength - props.maxLength / 2);
        const summary = computed(() => props.description.length > props.maxLength);
        const text = computed(() => props.description.length > props.maxLength ? props.description.slice(0, x) : props.description);
        return { __sfc: true, props, emit, propShowDetails, collapsedEnableIcon, collapsedDisableIcon, x, summary, text, FontAwesomeIcon };
    }
});
